// extracted by mini-css-extract-plugin
module.exports = {"item":"CourseItem-module--item--2Ccc9","itemMeta":"CourseItem-module--item--meta--17cS0"};